import { createContext } from 'react';

/**
 * Context for sharing state between InfrastructureTable parent and compound child components.
 *
 * This context enables the compound component pattern by providing shared state to all child
 * components (Content, SelectorContainer) without prop drilling.
 *
 * @type {React.Context<{
 *   tableId: string,
 *   columns: Array,
 *   data: Array,
 *   isLoading: boolean,
 *   error: object | null,
 *   emptyText: string,
 *   actionMenus: React.ReactNode,
 *   onSelectionChange: Function,
 *   visibleRows: number,
 *   useStyles: Function,
 *   dataArraySearchFields: Array,
 *   apiRef: object,
 *   isActioning: boolean,
 *   setIsActioning: Function,
 *   lastLoadDataArrayTime: number
 * } | null>}
 */
export const InfrastructureTableContext = createContext(null);
